import { FC } from 'react';
import { Modal, Form, FormField } from 'melp-design/components';
import { useTranslation } from 'react-i18next';
import { ModalProps } from 'store/modal';
import { ClaimStatus } from 'store/claims';

interface Values {
  comment: string;
}

const INITIAL_VALUES: Values = {
  comment: '',
};

interface Props extends ModalProps {
  title: string;
  action: 'request' | 'reject';
  closeModal: (
    param?:
      | { action: 'CLOSE' }
      | { action: 'REJECT'; payload: { comment: string; status: ClaimStatus } },
  ) => void;
}

export const ClaimRejectModal: FC<Props> = ({ title, action, closeModal }) => {
  const { t } = useTranslation();

  return (
    <Form<Values> defaultValues={INITIAL_VALUES}>
      {({ getValues, trigger }) => {
        return (
          <Modal.Content
            title={title}
            actions={[
              {
                variant: 'neutral-outline',
                onClick: () => closeModal({ action: 'CLOSE' }),
                label: t('common.cancel'),
              },
              ...(action === 'reject'
                ? [
                    {
                      variant: 'danger-outline',
                      label: t('global.actions.reject'),
                      onClick: async () => {
                        const valid = await trigger();

                        if (valid) {
                          closeModal({
                            action: 'REJECT',
                            payload: {
                              comment: getValues().comment,
                              status: 'rejected',
                            },
                          });
                        }
                      },
                    } as const,
                  ]
                : []),
              ...(action === 'request'
                ? [
                    {
                      variant: 'secondary',
                      label: t('claims.actions.request_extra_input'),
                      onClick: async () => {
                        const valid = await trigger();

                        if (valid) {
                          closeModal({
                            action: 'REJECT',
                            payload: {
                              comment: getValues().comment,
                              status: 'pendingEmployeeAction',
                            },
                          });
                        }
                      },
                    } as const,
                  ]
                : []),
            ]}
          >
            <FormField
              name="comment"
              label={t('claims.form.comment.label')}
              render="text"
              rules={{
                required: true,
                minLength: 10,
              }}
            />
          </Modal.Content>
        );
      }}
    </Form>
  );
};
